import { Component, OnInit } from '@angular/core';
import { UtilsService } from '../utils.service'

@Component({
  selector: 'app-login-box',
  templateUrl: './login-box.component.html',
  styleUrls: ['./login-box.component.css']
})
export class LoginBoxComponent implements OnInit {

  constructor(public utils: UtilsService) { }

  ngOnInit() {
  }
  get email() {
    let tpl = this.utils.email.split('@')
    return `<div>${tpl[0]}</div><div>@${tpl[1]}</div>`
  }
}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/login-box/login-box.component.ts